<template>
  <div class="new-place">
    <PageHeader title="場所追加登録" :backIcon="true" />
    <div class="contents-wrapper">
      <b-loading :is-full-page="false" :active="loading" />
      <div class="detail-contents">
        <div class="detail">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="場所名"
          >
            <b-tooltip v-if="isInitialSettingTutorialStep(4) && !loading" :class="{ 'top-index': isInitialSettingTutorialStep(4) }" position="is-bottom" type="is-success" multilined always>
              <template v-slot:content>
                <div><b>STEP2 場所を設定(2/3)</b></div>
                <p>場所名をご入力下さい。</p>
                <p>建物・最寄駅・会議室・など場所が分かる内容を入れて頂ければ大丈夫です。</p>
                <b-button @click="goToNextStep" class="next-button" :disabled="!isPlaceNameFilled">
                  入力しました！
                </b-button>
              </template>
              <b-field :type="{ 'is-danger': errors[0] }" :message="errors[0]">
                <template #label>
                  <span class="label-text">場所名</span>
                  <b-tag type="is-danger">必須</b-tag>
                </template>
                <b-input
                  class="form-item"
                  v-model="place.name"
                  placeholder="例）〇〇ビルA会議室、〇〇駅前喫茶店、etc..."
                ></b-input>
              </b-field>
            </b-tooltip>
            <b-field v-else :type="{ 'is-danger': errors[0] }" :message="errors[0]">
              <template #label>
                <span class="label-text">場所名</span>
                <b-tag type="is-danger">必須</b-tag>
              </template>
              <b-input
                class="form-item"
                v-model="place.name"
                placeholder="例）〇〇ビルA会議室、〇〇駅前喫茶店、etc..."
              ></b-input>
            </b-field>
          </ValidationProvider>
        </div>
      </div>
      <b-tooltip v-if="isInitialSettingTutorialStep(5)" position="is-bottom" type="is-success" multilined always>
        <template v-slot:content>
          <div><b>STEP2 場所を設定(2/3)</b></div>
          <p>ボタンをクリックして</p>
          <p>設定した場所を保存します</p>
        </template>
        <div class="add-button-wrapper">
          <b-button class="add-button" :class="{ 'top-index': isInitialSettingTutorialStep(5) }" expanded @click="onClickSaveButton">
            <p class="text is-size-6_5 has-text-weight-bold">場所を追加登録する</p>
          </b-button>
        </div>
      </b-tooltip>
      <div v-else class="add-button-wrapper">
        <b-button class="add-button" expanded @click="onClickSaveButton">
          <p class="text is-size-6_5 has-text-weight-bold">場所を追加登録する</p>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { defineComponent, reactive, toRefs, computed } from "@vue/composition-api";
import { useAuth } from "@/submodules/auth";

import { useSavePlaceMutation } from "../graphql/mutation/savePlace.generated";
import { useToast } from "@/submodules/toast";
import { useTutorialStore } from '@/stores/tutorial'

import PageHeader from "@/components/PageHeader.vue";

const { getToken } = useAuth();
const { toastError, setSessionMessage } = useToast();

const usePlaceMutation = () => {
  const { mutate: savePlaceMutate } = useSavePlaceMutation();
  const savePlace = (name) => {
    const result = savePlaceMutate({
      accessToken: getToken(),
      name,
    });

    return result;
  };

  return savePlace;
};

export default defineComponent({
  name: "NewPlace",
  components: {
    PageHeader,
  },
  setup(_, { root }) {
    const state = reactive({
      loading: false,
      place: {
        name: "",
      },
    });

    const savePlace = usePlaceMutation();
    const tutorial = useTutorialStore()

    const onClickSaveButton = async () => {
      try {
        await savePlace(state.place.name);
        tutorial.goToNextStep()
        setSessionMessage("場所を新規登録しました");
        root.$router.push("/tutorial/places");
      } catch (error) {
        console.error(error);
        toastError();
      }
    };
    const isInitialSettingTutorialStep = (step) => {
      return tutorial.current === 'INITIAL_SETTING' && tutorial.step == step
    }
    const goToNextStep = () => {
      tutorial.goToNextStep()
    }
    const isPlaceNameFilled = computed(() => {
      return !!state.place.name && state.place.name.length > 0
    })

    return {
      ...toRefs(state),
      onClickSaveButton,
      isInitialSettingTutorialStep,
      goToNextStep,
      isPlaceNameFilled,
    };
  },
});
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 16px 16px 72px;
}
.detail-contents {
  > .detail {
    width: 100%;
    text-align: left;
    padding-top: 16px;
    .name {
      height: 20px;
      white-space: nowrap;
    }

    .value {
      height: 20px;
    }
  }
}
::v-deep .button {
  color: white;
  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    .text {
      padding-left: 8px;
    }
  }
}
.add-button-wrapper {
  padding-top: 32px;
  .add-button {
    background-color: colors(green);
  }
}
::v-deep .tag {
  height: 16px;
  margin-left: 4px;
  color: white;
  &.attendee-tag {
    color: colors(black);
  }
  span {
    font-weight: 700;
  }
}
::v-deep .b-tooltip {
  width: 100%;
}
.top-index {
  z-index: 10;
  background-color: white;
  ::v-deep .button.next-button {
    height: 28px;
    color: gray;
    margin: 4px;
    font-size: 12px;
  }
}
</style>
